import { Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { MechanicTimeCodeBusinessService } from '../../business-services/mechanic-time-code.service';


@Injectable({ providedIn: 'root' })
export class EditMechanicTimeCodeGuard  {

  constructor(
    private mechanicTimeCodeService: MechanicTimeCodeBusinessService,
    private router: Router
  ) { }

  canActivate(): Promise<UrlTree | boolean> | Observable<UrlTree | boolean> | UrlTree | boolean {
    if (this.mechanicTimeCodeService.mechanicTimeCodeId) {
      return true;
    }
    return this.router.createUrlTree(['/mechanicTimeCode']);
  }
}
